import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    state: {
        type: "select",
        label: "State",
        isRequired: true,
        options : [],
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    city: {
        type: "select",
        label: "City",
        isRequired: true,
        options : [],
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
        }
    },
    pincode: {
        type: "input",
        label: "Pincode",
        isRequired: true,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            format: {
                message: VALIDATION_MESSAGES.INVALID,
                pattern: REGEX_PATTERNS.PINCODE
            }
        }
    }
};

export default FIELDS;